module.exports = "<br>\r\n<h5 class=\"text-center\">\r\n  Por favor seleccione un tr&aacute;mite de la lista para comenzar.\r\n</h5>"